import React from 'react';
import { Language } from '../App';
import { PageHero } from '../components/PageHero';
interface EditorialPolicyProps {
  language: Language;
}
export function EditorialPolicy({
  language
}: EditorialPolicyProps) {
  const isPashto = language === 'pashto';
  const policies = isPashto ? [{
    title: 'سیاسي بې طرفي',
    text: 'پاڅون مجله د هیڅ سیاسي ګوند، تحریک یا حکومت سره تړاو نلري. موږ هیڅ سیاسي نظرونه نه خپروو او نه یې ملاتړ کوو. زموږ ټوله پاملرنه د پښتو ژبې او ادب ته وقف ده.'
  }, {
    title: 'اصلي منځپانګه',
    text: 'ټول مقالې، شعرونه او لیکنې باید اصلي وي او مخکې په بله مجله، ورځپاڼه یا ویبپاڼه کې نه وي خپرې شوې.'
  }, {
    title: 'تحریري خپلواکي',
    text: 'زموږ مدیران د خپرونې په اړه خپلواک پریکړې کوي. هیڅ بهرنی فشار د منځپانګې په انتخاب اغیزه نه کوي.'
  }, {
    title: 'درناوی او وقار',
    text: 'موږ هغه منځپانګه نه خپروو چې نفرت، تبعیض یا تاوتریخوالی ته وهڅوي. ټولې خپرونې باید د ادب او درناوي معیارونه ومني.'
  }, {
    title: 'د لیکوالانو حقونه',
    text: 'لیکوالان د خپلو آثارو بشپړ حقونه ساتي. پاڅون یوازې د خپرولو اجازه ترلاسه کوي. لیکوالان کولای شي خپل آثار بل ځای هم خپاره کړي.'
  }, {
    title: 'تصحیح',
    text: 'که چیرې کومه تیروتنه وشي، موږ به یې ژر تصحیح کړو او په راتلونکې ګڼه کې به یې اعلان وکړو.'
  }] : [{
    title: 'Political Neutrality',
    text: 'Pasoon magazine has no affiliation with any political party, movement, or government. We do not publish or endorse political views. Our entire focus is dedicated to the Pashto language and literature.'
  }, {
    title: 'Original Content',
    text: 'All articles, poems, and writings must be original and not previously published in any other magazine, newspaper, or website.'
  }, {
    title: 'Editorial Independence',
    text: 'Our editors make independent decisions about publication. No external pressure influences content selection.'
  }, {
    title: 'Respect & Dignity',
    text: 'We do not publish content that incites hatred, discrimination, or violence. All publications must meet standards of decency and respect.'
  }, {
    title: 'Author Rights',
    text: 'Authors retain full rights to their work. Pasoon only obtains permission to publish. Authors may republish their work elsewhere.'
  }, {
    title: 'Corrections',
    text: 'If an error is published, we will promptly correct it and announce the correction in the following issue.'
  }];
  return <div className="pt-24 md:pt-28" data-id="element-546">
      <PageHero language={language} titleEn="Editorial Policy" titlePs="تحریري پالیسي" introEn="Our commitment to independent, non-political, and quality Pashto literary publishing." introPs="د خپلواک، غیر سیاسي او د کیفیت لرونکي پښتو ادبي خپرونو ته زموږ ژمنه." data-id="element-547" />

      <section className="py-20 bg-white px-6" data-id="element-548">
        <div className="max-w-3xl mx-auto space-y-10" data-id="element-549">
          {policies.map((policy, idx) => <div key={idx} className="border-b border-gray-100 pb-8 last:border-0" data-id="element-550">
              <h3 className={`text-xl font-bold text-pasoon-dark mb-3 ${isPashto ? 'font-pashto' : 'font-serif'}`} data-id="element-551">
                {policy.title}
              </h3>
              <p className={`text-gray-600 ${isPashto ? 'font-pashto leading-loose' : 'leading-relaxed'}`} data-id="element-552">
                {policy.text}
              </p>
            </div>)}
        </div>
      </section>
    </div>;
}